<template>
  <div>
    <div class="show-filters-btn" @click="showFilters = true">
      <img src="/static/controls.svg" alt="">
      <span>FILTERS</span>
    </div>
    <aside class="filters-bar el-aside" :class="{active: showFilters}" v-loading="isLoading">
      <div class="desktop-search">
        <el-input placeholder="Search" v-model="$store.state.search"
                  class="input-with-select hidden-xs-only searchbar"
                  @keyup.enter.native="searchHandler">
          <el-button slot="append" icon="el-icon-search" @click="searchHandler"></el-button>
        </el-input>
      </div>
      <div class="scrollable" v-if="!isLoading">

        <el-input placeholder="Search" v-model="$store.state.search"
                  class="input-with-select search-cnt hidden-sm-and-up">
          <!--<el-button slot="append" icon="el-icon-search" @click=""></el-button>-->
        </el-input>
        <el-collapse v-model="activeNames" style="border-top: 0">

          <el-collapse-item class="checkbox-fullwidth-cnt" name="category">
            <template slot="title">
              <div class="filte-by">Topics</div>
            </template>
            <el-checkbox :indeterminate="filters.category.isIndeterminate" v-model="filters.category.checkAll"
                         @change="handleCheckAllChange($event, 'category')">
              Check all
            </el-checkbox>
            <el-checkbox-group v-model="filters.category.checkedFilters"
                               @change="handleCheckedChange($event, 'category')">
              <el-checkbox v-for="item in filters.category.filterItems" :label="item" :key="item.id">{{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>

          <el-collapse-item class="checkbox-fullwidth-cnt" name="other">
            <template slot="title">
              <div class="filte-by">Filters</div>
            </template>

            <div class="checkbox-fullwidth-cnt">
              <div class="d-flex justify-between align-center" style="padding: 0 15px 20px 15px;">
                <span style="color: #606266; text-transform: uppercase">Has quiz</span>
                <el-switch
                    v-model="$store.state.filters.has_quiz"
                    @change="setFilters"
                    active-text=""
                    active-color="#13ce66"
                    inactive-color="#409eff">
                </el-switch>
              </div>
              <div class="d-flex justify-between align-center" style="padding: 0 15px 20px 15px;">
                <span style="color: #606266; text-transform: uppercase">Has Livelabels</span>
                <el-switch
                    v-model="$store.state.filters.has_labels"
                    @change="setFilters"
                    active-text=""
                    active-color="#13ce66"
                    inactive-color="#409eff">
                </el-switch>
              </div>
            </div>
            <div style="color: #606266; text-transform: uppercase; padding: 0 15px">Minimum slides</div>
            <div style="padding: 0 10px 0 15px" class="d-flex">
              <el-slider :show-tooltip="false"
                         class="flex-grow"
                         v-model="$store.state.filters.min_slides"
                         :min="1"
                         :max="100"
                         @change="setFilters('min')"></el-slider>
              <span class="filter-slider-display">{{$store.state.filters.min_slides}}</span>
            </div>
            <div style="color: #606266; text-transform: uppercase; padding: 0 15px">Maximum slides</div>
            <div style="padding: 0 10px 0 15px" class="d-flex">
              <el-slider :show-tooltip="false"
                         class="flex-grow"
                         v-model="$store.state.filters.max_slides"
                         :min="1"
                         :max="100"
                         @change="setFilters('max')"></el-slider>
              <span class="filter-slider-display">{{$store.state.filters.max_slides}}</span>
            </div>
          </el-collapse-item>

          <el-collapse-item class="checkbox-fullwidth-cnt" name="grade">
            <template slot="title">
              <div class="filte-by">Grade</div>
            </template>
            <div style="padding: 0 10px 0 15px" class="d-flex">
              <el-slider :show-tooltip="false"
                         class="flex-grow"
                         v-model="$store.state.filters.grade"
                         :min="0"
                         :max="gradesMap.length-1"
                         @change="setFilters"></el-slider>
              <span class="filter-slider-display">{{gradesMap[$store.state.filters.grade]}}</span>
            </div>
          </el-collapse-item>

          <el-collapse-item class="checkbox-fullwidth-cnt" name="tag">
            <template slot="title">
              <div class="filte-by">NGSS</div>
            </template>
            <div style="padding: 0 10px">

              <el-select v-model="filters.standard1" placeholder="1 level" clearable @change="filters.standard2 = null">
                <el-option
                    v-for="item, i in standardsSelect"
                    :key="item.name"
                    :label="item.name"
                    :value="i">
                </el-option>
              </el-select>
              <el-select style="margin-top: 10px" v-model="filters.standard2" clearable placeholder="2 level" v-if="filters.standard1">
                <el-option
                    v-for="item, i in standardsSelect[filters.standard1].items"
                    :key="item.name"
                    :label="item.name"
                    :value="i">
                </el-option>
              </el-select>

              <el-checkbox-button
                  class="custom-checkbox-button"
                  v-for="item in filters.tag.filterItems"
                  v-model="filters.tag.checkedFilters"
                  :label="item"
                  :key="item.id"
                  @change="handleCheckedChange($event, 'tag')">
                {{item.name}}
              </el-checkbox-button>
            </div>
          </el-collapse-item>

        </el-collapse>
      </div>
      <div class="submit-cnt flex-center hidden-sm-and-up">
        <el-button type="primary" @click="submitFilters">Submit</el-button>
      </div>
    </aside>
  </div>
</template>

<script>
  import standardsSelect from "../constants/standards"
  export default {
    name: 'Filters',
    props: {
      searchEnabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        quiz: false,
        isLoading: 0,
        showFilters: false,
        activeNames: ['other', 'grade', 'tag', 'category'], //SPOILERS OPEN BY DEFAULT
        filtersToGet: ["category"], //ARRAY OF FILTER SLUGS TO GET FROM API
        filters: {
          category: {},
          tag: {},
          mediaType: {
            checkedFilters: [],
            isIndeterminate: true,
            checkAll: false,
            filterItems: [
              {id: 1, name: "Full tour"},
              {id: 2, name: "Object"},
              {id: 3, name: "Image"},
              {id: 4, name: "Texture"},
              {id: 5, name: "Background"}
            ]
          },
          standard1: null,
          standard2: null,
        },
        gradesMap: ["K", "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th"],
        standardsSelect: standardsSelect,
        secondSelect: [

        ]
      }
    },
    mounted: function () {
      let filtersQuery = {};
      for (let key in this.$route.query) {
        if (key === "search") {
          this.$store.commit("setState", {search: this.$route.query[key]})
        } else {
          filtersQuery[key] = this.$route.query[key].split(",");
        }
      }
      this.isLoading = true;
      let promises = [];
      this.filtersToGet.forEach((filter) => {
        promises.push(this.axios.get(this.$store.state.API_URL + filter)
          .then(response => {
            if (!response.error) {
              this.filters[filter] = {
                checkedFilters: [],
                isIndeterminate: true,
                checkAll: false,
              };
              this.filters[filter].filterItems = response.data.map((item) => {
                let f = {name: item.name, id: item.id};
                if (filtersQuery[filter] && filtersQuery[filter].indexOf(f.name) !== -1) {
                  this.filters[filter].checkedFilters.push(f);
                }
                return f;
              });
            }
          }).catch((err) => {
            // console.log(err.response);
          })
        );
      });
      Promise.all(promises).then((res) => {
        this.isLoading = false;
        this.setFilters();
        this.submitFilters();
      })
    },
    methods: {
      submitFilters() {
        this.showFilters = false;
        this.$emit('submitFilters')
      },
      searchHandler() {
        if (this.$store.state.libLoading) {
          return;
        }
        this.$store.state.libLoading = true;

        this.axios.post(this.$store.state.API_URL + 'demo/filter', {
          filters: this.$store.state.filters,
          search: this.$store.state.search,
          start: 0,
          limit: 64
        }).then((res) => {
          this.$store.commit("setState", {libraryItems: res.data});
          this.$store.state.libLoading = false;
          this.$router.replace({query: Object.assign({}, this.$store.getters.query)});
        });

      },
      setFilters(name) {
        this.isLoading = true;
        this.$store.commit("setState", {libLoading: true});
        console.log(name);
        if (name === "min" && this.$store.state.filters.min_slides > this.$store.state.filters.max_slides) {
          this.$store.state.filters.min_slides = this.$store.state.filters.max_slides;
        }
        if (name === "max" && this.$store.state.filters.max_slides < this.$store.state.filters.min_slides) {
          this.$store.state.filters.max_slides = this.$store.state.filters.min_slides;
        }
        let filtersObj = {};
        for (let key in this.$store.state.filters) {
          if (Array.isArray(this.$store.state.filters[key])) {
            filtersObj[key] = this.filters[key].checkedFilters;
          } else {
            filtersObj[key] = this.$store.state.filters[key];
          }
        }
        this.$store.commit("setFilters", filtersObj);
        this.$router.replace({query: Object.assign({}, this.$store.getters.query)});
        this.axios.post(this.$store.state.API_URL + 'demo/filter', {
          filters: this.$store.state.filters,
          search: this.$store.state.search,
          start: 0,
          limit: 64
        }).then(response => {
          this.$store.commit("setState", {allLoaded: false, libraryItems: response.data, libLoading: false});
          this.isLoading = false;
          setTimeout(() => {
            this.$redrawVueMasonry();
          }, 100)
        });
      },
      handleCheckAllChange(val, key) {
        this.$store.commit("setState", {allLoaded: false});
        this.filters[key].checkedFilters = val ? this.filters[key].filterItems : [];
        this.filters[key].isIndeterminate = false;
        this.setFilters();
      },
      handleCheckedChange(val, key) {
        console.log(val, key);
        let checkedCount = val.length;
        this.$store.commit("setState", {allLoaded: false});
        this.filters[key].checkAll = checkedCount === this.filters[key].filterItems.length;
        this.filters[key].isIndeterminate = checkedCount > 0 && checkedCount < this.filters[key].filterItems.length;
        this.setFilters();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/filters.vue